import React from 'react';
import { Link } from 'react-router-dom';
import { HandshakeIcon, TicketIcon, CalendarIcon, UsersIcon, TrendingUpIcon, BarChartIcon, CheckCircleIcon, ArrowRightIcon, BuildingIcon, CreditCardIcon, TagIcon, HeartIcon } from 'lucide-react';
const Partner = () => {
  return <div className="pb-16" data-id="element-2837">
      <div className="border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800" data-id="element-2838">
        <div className="max-w-4xl mx-auto p-4" data-id="element-2839">
          <h1 className="text-2xl font-bold mb-2 flex items-center" data-id="element-2840">
            <HandshakeIcon className="w-6 h-6 mr-2" data-id="element-2841" />
            Let's Partner
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-2842">
            Grow your business with JoinToday.co.ke - Kenya's community platform
          </p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto p-4" data-id="element-2843">
        {/* Hero Section */}
        <div className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden mb-8" data-id="element-2844">
          <div className="h-48 bg-gray-200 dark:bg-gray-700 border-b border-gray-300 dark:border-gray-600 flex items-center justify-center" data-id="element-2845">
            <div className="text-center p-6" data-id="element-2846">
              <h2 className="text-xl font-bold mb-2" data-id="element-2847">
                Partner With Kenya's Fastest Growing Community Platform
              </h2>
              <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-2848">
                Reach engaged audiences, sell tickets, promote events, and grow
                your business with JoinToday.co.ke
              </p>
              <div className="flex justify-center" data-id="element-2849">
                <Link to="/register" className="px-4 py-2 bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-800 rounded-md mr-3" data-id="element-2850">
                  Get Started
                </Link>
                <a href="https://wa.me/254100254254" target="_blank" rel="noopener noreferrer" className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md" data-id="element-2851">
                  Contact Sales
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Partnership Options */}
        <h2 className="text-xl font-bold mb-4" data-id="element-2852">Partner With Us</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-2853">
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-2854">
            <div className="flex items-center mb-4" data-id="element-2855">
              <TicketIcon className="w-8 h-8 mr-3" data-id="element-2856" />
              <h3 className="text-lg font-bold" data-id="element-2857">Event Ticketing Solutions</h3>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-2858">
              Sell tickets for your events with our powerful ticketing platform.
              Manage attendees, collect payments, and boost your event
              visibility.
            </p>
            <ul className="space-y-2 mb-4" data-id="element-2859">
              <li className="flex items-start" data-id="element-2860">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2861" />
                <span className="text-sm" data-id="element-2862">
                  Customizable ticket types and pricing
                </span>
              </li>
              <li className="flex items-start" data-id="element-2863">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2864" />
                <span className="text-sm" data-id="element-2865">Mobile tickets with QR codes</span>
              </li>
              <li className="flex items-start" data-id="element-2866">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2867" />
                <span className="text-sm" data-id="element-2868">
                  Secure payment processing (M-Pesa integration)
                </span>
              </li>
              <li className="flex items-start" data-id="element-2869">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2870" />
                <span className="text-sm" data-id="element-2871">
                  Real-time sales reporting and analytics
                </span>
              </li>
            </ul>
            <Link to="/ticketing-services" className="text-sm flex items-center text-gray-800 dark:text-gray-200" data-id="element-2872">
              Learn more about our ticketing services{' '}
              <ArrowRightIcon className="w-3 h-3 ml-1" data-id="element-2873" />
            </Link>
          </div>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-2874">
            <div className="flex items-center mb-4" data-id="element-2875">
              <BuildingIcon className="w-8 h-8 mr-3" data-id="element-2876" />
              <h3 className="text-lg font-bold" data-id="element-2877">Sell on JoinToday</h3>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-2878">
              List your products and services on our marketplace and reach
              thousands of potential customers across Kenya.
            </p>
            <ul className="space-y-2 mb-4" data-id="element-2879">
              <li className="flex items-start" data-id="element-2880">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2881" />
                <span className="text-sm" data-id="element-2882">
                  Create your branded seller profile
                </span>
              </li>
              <li className="flex items-start" data-id="element-2883">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2884" />
                <span className="text-sm" data-id="element-2885">
                  List unlimited products or services
                </span>
              </li>
              <li className="flex items-start" data-id="element-2886">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2887" />
                <span className="text-sm" data-id="element-2888">Secure payment processing</span>
              </li>
              <li className="flex items-start" data-id="element-2889">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2890" />
                <span className="text-sm" data-id="element-2891">Customer reviews and ratings</span>
              </li>
            </ul>
            <Link to="/register" className="text-sm flex items-center text-gray-800 dark:text-gray-200" data-id="element-2892">
              Register as a seller <ArrowRightIcon className="w-3 h-3 ml-1" data-id="element-2893" />
            </Link>
          </div>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-2894">
            <div className="flex items-center mb-4" data-id="element-2895">
              <TagIcon className="w-8 h-8 mr-3" data-id="element-2896" />
              <h3 className="text-lg font-bold" data-id="element-2897">
                Promote Your Deals & Discounts
              </h3>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-2898">
              Feature your special offers, deals, and discounts to our community
              of deal-seeking Kenyans.
            </p>
            <ul className="space-y-2 mb-4" data-id="element-2899">
              <li className="flex items-start" data-id="element-2900">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2901" />
                <span className="text-sm" data-id="element-2902">
                  Featured placement in our Deals section
                </span>
              </li>
              <li className="flex items-start" data-id="element-2903">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2904" />
                <span className="text-sm" data-id="element-2905">
                  Targeted promotion to relevant audiences
                </span>
              </li>
              <li className="flex items-start" data-id="element-2906">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2907" />
                <span className="text-sm" data-id="element-2908">
                  Track coupon usage and conversions
                </span>
              </li>
              <li className="flex items-start" data-id="element-2909">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2910" />
                <span className="text-sm" data-id="element-2911">Limited-time flash deals</span>
              </li>
            </ul>
            <Link to="/register" className="text-sm flex items-center text-gray-800 dark:text-gray-200" data-id="element-2912">
              Submit your deals <ArrowRightIcon className="w-3 h-3 ml-1" data-id="element-2913" />
            </Link>
          </div>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-2914">
            <div className="flex items-center mb-4" data-id="element-2915">
              <TrendingUpIcon className="w-8 h-8 mr-3" data-id="element-2916" />
              <h3 className="text-lg font-bold" data-id="element-2917">Advertising Opportunities</h3>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-2918">
              Promote your brand with targeted advertising across our platform,
              reaching engaged Kenyan audiences.
            </p>
            <ul className="space-y-2 mb-4" data-id="element-2919">
              <li className="flex items-start" data-id="element-2920">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2921" />
                <span className="text-sm" data-id="element-2922">
                  Banner ads on high-traffic pages
                </span>
              </li>
              <li className="flex items-start" data-id="element-2923">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2924" />
                <span className="text-sm" data-id="element-2925">
                  Sponsored content and featured listings
                </span>
              </li>
              <li className="flex items-start" data-id="element-2926">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2927" />
                <span className="text-sm" data-id="element-2928">
                  Community and event sponsorships
                </span>
              </li>
              <li className="flex items-start" data-id="element-2929">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-2930" />
                <span className="text-sm" data-id="element-2931">Detailed performance analytics</span>
              </li>
            </ul>
            <a href="mailto:advertising@jointoday.co.ke" className="text-sm flex items-center text-gray-800 dark:text-gray-200" data-id="element-2932">
              Get our media kit <ArrowRightIcon className="w-3 h-3 ml-1" data-id="element-2933" />
            </a>
          </div>
        </div>
        {/* Why Partner With Us */}
        <div className="mb-8" data-id="element-2934">
          <h2 className="text-xl font-bold mb-4" data-id="element-2935">
            Why Partner With JoinToday.co.ke?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-2936">
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 text-center" data-id="element-2937">
              <UsersIcon className="w-8 h-8 mx-auto mb-2" data-id="element-2938" />
              <h3 className="font-bold mb-1" data-id="element-2939">Growing Community</h3>
              <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-2940">
                Access thousands of engaged Kenyans actively participating in
                communities and events.
              </p>
            </div>
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 text-center" data-id="element-2941">
              <BarChartIcon className="w-8 h-8 mx-auto mb-2" data-id="element-2942" />
              <h3 className="font-bold mb-1" data-id="element-2943">Detailed Analytics</h3>
              <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-2944">
                Get comprehensive insights into your performance and audience
                engagement.
              </p>
            </div>
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 text-center" data-id="element-2945">
              <CreditCardIcon className="w-8 h-8 mx-auto mb-2" data-id="element-2946" />
              <h3 className="font-bold mb-1" data-id="element-2947">Secure Payments</h3>
              <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-2948">
                Reliable payment processing with M-Pesa integration and timely
                settlements.
              </p>
            </div>
          </div>
        </div>
        {/* Success Stories */}
        <div className="mb-8" data-id="element-2949">
          <h2 className="text-xl font-bold mb-4" data-id="element-2950">Partner Success Stories</h2>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-2951">
            <div className="flex items-start" data-id="element-2952">
              <div className="w-16 h-16 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-2953">
                <span className="text-lg font-bold" data-id="element-2954">NE</span>
              </div>
              <div data-id="element-2955">
                <h3 className="font-bold mb-1" data-id="element-2956">Nairobi Events Ltd</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-3" data-id="element-2957">
                  "Since using JoinToday's ticketing platform, we've seen a 40%
                  increase in our event attendance and significantly streamlined
                  our check-in process. The platform's ease of use and M-Pesa
                  integration has been a game-changer for our business."
                </p>
                <p className="text-sm font-medium" data-id="element-2958">
                  - Sarah Kamau, Events Director
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* CTA Section */}
        <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6 text-center" data-id="element-2959">
          <HeartIcon className="w-12 h-12 mx-auto mb-3" data-id="element-2960" />
          <h2 className="text-xl font-bold mb-2" data-id="element-2961">Ready to Partner With Us?</h2>
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4 max-w-lg mx-auto" data-id="element-2962">
            Join the growing number of businesses and event organizers who are
            leveraging JoinToday.co.ke to reach new customers and grow their
            business.
          </p>
          <div className="flex justify-center" data-id="element-2963">
            <Link to="/register" className="px-6 py-2 bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-800 rounded-md mr-3" data-id="element-2964">
              Become a Partner
            </Link>
            <a href="https://wa.me/254100254254" target="_blank" rel="noopener noreferrer" className="px-6 py-2 border border-gray-300 dark:border-gray-600 rounded-md" data-id="element-2965">
              Talk to Sales
            </a>
          </div>
        </div>
      </div>
    </div>;
};
export default Partner;